export function formatToLocalDate(dateString) {
  if (!dateString) return ""; // se manca la data
  const date = new Date(dateString);
  // Estrai anno, mese, giorno
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${day}/${month}/${year}`;
}

export function formatToLocalDateAndHours(dateString) {
  if (!dateString) return ""; // se manca la data
  const date = new Date(dateString);
  // Estrai anno, mese, giorno
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  // aggiungo la data in formato ITA
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");

  return `${day}/${month}/${year} ${hours}:${minutes}`;
}

/**
 * Formatta un numero in stile italiano: punto separatore delle migliaia e
 * virgola per i decimali (es. 1234.5 -> "1.234,50").
 * Solo per la visualizzazione: non usare per valori di input o payload API.
 */
export function formatDecimal(value, decimals = 2) {
  const n = Number(value);
  if (!isFinite(n)) return "";
  const fixed = Math.abs(n).toFixed(decimals); // es. "1183.00"
  const [intPart, decPart] = fixed.split(".");
  // Punto come separatore delle migliaia
  const grouped = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  const body = decPart ? `${grouped},${decPart}` : grouped;
  return n < 0 ? `-${body}` : body;
}

export function formatPriceToPrint(price) {
  const currencySymbol = "€"; // Cambia in "$" per il dollaro
  const result = `${currencySymbol} ${formatDecimal(price, 2)}`;
  // console.log("Formatted price:", result);
  return result;
}

/**
 * Prende una stringa ISO 8601 con Z o offset
 * e restituisce "YYYY-MM-DDThh:mm"
 * compatibile con <input type="datetime-local">
 */
export function toDateTimeLocal(value) {
  if (!value) return "";
  // crea il Date JS a partire dalla stringa ISO
  const d = new Date(value);
  // trasforma in millisecondi locali
  const tzOffset = d.getTimezoneOffset() * 60000;
  const localTs = d.getTime() - tzOffset;
  // ricava stringa ISO e taglia al minuto
  return new Date(localTs).toISOString().slice(0, 16);
}

export function toDateLocal(value) {
  if (!value) return "";
  const d = new Date(value);
  const tzOffset = d.getTimezoneOffset() * 60000;
  const localTs = d.getTime() - tzOffset;
  return new Date(localTs).toISOString().slice(0, 10);
}
